export const data = [
  {
    id: 1,
    name: "الدرس الاول",
    title: "مهارة الأمان الرقمي",
    video: "/test1.mp4",

    Objectives: `1-أن يعرّف مفهوم الأمان الرقمي.
2-أن يميّز بين السلوك الآمن وغير الآمن في الفضاء الرقمي.
3-أن يُطبق ممارسات الأمان الرقمي في بيئة مركز مصادر التعلم.
`,
    content: `
يعتبر أمن المعلومات في الوقت الراهن من الركائز الأساسية لتحقيق استقرار المجتمعات، حيث يسهم بشكل كبير في دعم الاقتصاد الوطني وتنمية الدول التي تعتمد بشكل أساسي على التكنولوجيا. فهو يمثل العمود الفقري لنهضة تكنولوجيا المعلومات والاتصالات التي تعتمد عليها المؤسسات على الصعيدين الداخلي والخارجي. وفي هذا السياق، أصبحت مسألة الأمن السيبراني من أبرز التحديات الإقليمية والعالمية، خاصة مع تزايد التهديدات الأمنية الإلكترونية، سواء من حيث عدد الهجمات أو حجم الأضرار الناتجة عنها.
أبرز التهديدات الرقمية التي قد تواجهك كأخصائي مصادر تعلم
1-حماية البيانات الشخصية من المخاطر التي قد تؤدي إلى سرقة الهوية أو التعرض للابتزاز والاحتيال.
2-توخي الحذر واليقظة أثناء استخدام التطبيقات ومواقع التواصل الاجتماعي المختلفة لضمان الأمان الرقمي.
3-التعرف على الأساليب الفعّالة للتصدي للشائعات والتعامل مع الحملات الإلكترونية الموجهة والجيوش الرقمية بشكل واعٍ ومسؤول.
4-التعرف على آليات حجب المواقع غير الآمنة التي تشكل تهديدًا على الخصوصية الشخصية أو أمن الدولة.
استراتيجيات لحماية نفسك ومركز مصادر التعلم
1-استخدم كلمات مرور قوية ومعقدة (وتغيّرها بشكل دوري).
2-لا تفتح أي رابط مشبوه أو بريد من جهة غير معروفة.
3-فعّل خاصية التحقق بخطوتين (2FA) في حساباتك.
4-قم بتحديث برامجك وأنظمتك باستمرار.
5-استخدم برامج حماية أصلية (Antivirus + Firewall).
6-احذر من تخزين ملفات الطلاب أو المدرسة على جهازك الشخصي.
7-استخدم النسخ الاحتياطي للملفات المهمة بانتظام.
`,
    questions: [
      { time: 5, question: "أخصائي مصادر التعلم لاحظ أن بعض المعلمين يستخدمون كلمة مرور واحدة لجميع الحسابات، ما التصرف الأنسب؟", options: ["تجاهل الأمر لأنه لا يخص المركز", "إرسال بريد تحذيري للجميع بلغة شديدة", "تقديم ورشة توعوية عن الأمن الرقمي وكلمات المرور القوية", "تغيير كلمات مرورهم دون علمهم"], answer: "تقديم ورشة توعوية عن الأمن الرقمي وكلمات المرور القوية" },
      { time: 10, question: "أي من هذه التصرفات يُعد تهديدًا مباشرًا للأمان الرقمي داخل المدرسة؟", options: ["حفظ الملفات على وحدة تخزين سحابية مؤمنة", "مشاركة بيانات الدخول بين المعلمين لتسهيل العمل", "استخدام برامج مكافحة فيروسات محدثة", "التحقق الثنائي للدخول إلى البريد الإلكتروني"], answer: "مشاركة بيانات الدخول بين المعلمين لتسهيل العمل" },
    ],
    isDone: true,
    jumpToTime: 210,
    stopAtTime: 204,
    xPercent: 91.5,
    yPercent1: 58.5,
    yPercent2: 69.5,
    xPercent2: 90,
    yPercent3: 28,
    yPercent4: 40,
  },
  {
    id: 2,
    name: "الدرس الثاني",
    title: "التواصل الرقمي المسؤول",

    video: "/test2.mp4",
    Objectives: `1-أن يُعرّف المتدرب مفهوم التواصل الرقمي المسؤول وأهميته في البيئة التعليمية.
2-أن يُميّز بين أمثلة للتواصل الرقمي الإيجابي والسلبي في مواقف عملية.
3-أن يتجنب السلوكيات الخاطئة أثناء التفاعل عبر الإنترنت، ويلتزم بآداب التعامل الرقمي.
`,
    content: `
مفهوم التواصل الرقمي المسؤول وأهميته
.التواصل الرقمي المسؤول هو الاستخدام الواعي والمهذب لأدوات الاتصال الإلكترونية بما يضمن احترام القوانين والأعراف، وصون حقوق الآخرين، وتحقيق التفاعل الإيجابي عبر الفضاء الرقمي.وتكمن أهميته في:
1-تعزيز الثقة بين أفراد المجتمع التعليمي.
2-الحد من النزاعات أو إساءة الفهم عبر الرسائل والمنشورات.
3-بناء صورة مهنية إيجابية للأخصائي أمام الطلاب والزملاء.
4-المساهمة في نشر ثقافة رقمية قائمة على الاحترام والمسؤولية.


التواصل الرقمي الإيجابي: يتمثل في استخدام لغة واضحة ومهذبة، الرد في الوقت المناسب، مشاركة محتوى نافع وموثوق، احترام الخصوصية، وتقديم النقد بأسلوب بنّاء.
التواصل الرقمي السلبي: يشمل استخدام لغة جارحة أو ساخرة، تجاهل الرسائل الهامة، نشر شائعات أو معلومات مضللة، مشاركة بيانات أو صور دون إذن، والمبالغة في استخدام الرموز أو التعليقات غير اللائقة.


1-تجنب السلوكيات الخاطئة والالتزام بالآداب الرقمية
2-لتجنّب السلوكيات الخاطئة في التفاعل عبر الإنترنت، ينبغي على المتدرب:
3-التفكير قبل النشر أو المشاركة والتأكد من صحة المعلومة.
4-عدم مشاركة كلمات المرور أو البيانات الشخصية.
5-تجنّب الردود الانفعالية أو المسيئة في النقاشات.
6-احترام خصوصية الآخرين وعدم مشاركة محتوياتهم دون إذن.
7-الالتزام باستخدام أسلوب مهني في جميع المراسلات الرسمية.
لتواصل الرقمي المسؤول ليس مجرد مهارة مكتسبة، بل هو انعكاس لقيم الفرد وسلوكه في الفضاء الرقمي. ومن خلال هذه الممارسة، يساهم أخصائي مصادر التعلم في بناء بيئة تعليمية أكثر احترامًا، وأمانًا، وتعاونًا.

`,

    questions: [
      { time: 5, question: "أحد المعلمين يرسل يوميًا رسائل إعلانية في مجموعة الواتساب الخاصة بالمدرسة، مما سبب انزعاجًا. ما الإجراء الأنسب من أخصائي مصادر التعلم؟", options: ["تجاهل الموضوع فهو لا يخص المركز", "حذف المعلم من المجموعة", "اقتراح سياسة تنظيم التواصل الرقمي داخل المدرسة", "مطالبة الإدارة بإغلاق المجموعة"], answer: "اقتراح سياسة تنظيم التواصل الرقمي داخل المدرسة" },
      { time: 10, question: "أفضل طريقة لأخصائي مصادر التعلم لتفعيل التواصل الرقمي المهني مع الطلاب هي:", options: ["استخدام البريد الإلكتروني الرسمي للمدرسة", "التواصل عبر حسابه الشخصي في مواقع التواصل", "إرسال ملفات العمل عبر تطبيق واتساب", "السماح بالدردشة المفتوحة دون رقابة"], answer: "استخدام البريد الإلكتروني الرسمي للمدرسة" },
    ],
    isDone: true,
    jumpToTime: 210,
    stopAtTime: 204,
    xPercent: 91.5,
    yPercent1: 58.5,
    yPercent2: 69.5,
    xPercent2: 90,
    yPercent3: 28,
    yPercent4: 40,

  },
  {
    id: 3,
    name: "الدرس الثالث",
    title: "المسؤولية الرقمية",
    video: "/test3.mp4",

    questions: [
      { time: 5, question: "عند مشاركة المحتوى الرقمي داخل مركز مصادر التعلم، يجب التأكد من:", options: ["حذف اسم المؤلف لتجنب المخالفة", ". نسخ المحتوى كما هو من المواقع التعليمية", "نسبة المحتوى لصاحبه واحترام الملكية الفكرية", "تغيير صيغة الملف فقط لإعادة الاستخدام"], answer: "نسبة المحتوى لصاحبه واحترام الملكية الفكرية" },
      { time: 10, question: "أحد الطلاب نشر صور من داخل المركز على وسائل التواصل بدون إذن. ما التوجيه الصحيح من الأخصائي؟", options: ["حظره من استخدام الإنترنت", "توعيته بأهمية الموافقة المسبقة واحترام الخصوصية", "حذف الصور بنفسه من حساب الطالب", "تجاهل الموضوع لأنه تصرف فردي"], answer: "توعيته بأهمية الموافقة المسبقة واحترام الخصوصية" },
    ],
    Objectives: `1-أن يُعرّف المتدرب مفهوم المسؤولية الرقمية وأهميتها في المجتمع التعليمي.
2-أن يُحلل المتدرب مواقف مرتبطة باستخدام غير مسؤول للمعلومات الرقمية.
3-أن يُطبق المتدرب سلوكيات صحيحة تعكس التزامه بالقوانين والحقوق الرقمية.
`,
    content: `
المسؤولية الرقمية تعني الالتزام بالقيم الأخلاقية والقوانين أثناء استخدام التكنولوجيا، بما يضمن احترام حقوق الآخرين وصون البيانات والمحتويات الرقمية.وتبرز أهميتها في:

1-الحفاظ على السمعة الرقمية للفرد والمؤسسة.
2-حماية حقوق الملكية الفكرية عند استخدام أو نشر المعلومات.
3-الحد من انتشار الأخبار الكاذبة أو المحتويات المضللة.
4-المساهمة في بناء مجتمع رقمي واعٍ ومتوازن.

. نسخ مقالات أو صور من الإنترنت دون ذكر المصدر ➝ سلوك غير مسؤول لأنه انتهاك للملكية الفكرية.
. نشر صور لطلاب في المنصات التعليمية بدون إذن ➝ إخلال بالخصوصية.
. مشاركة مواد تعليمية مزيفة أو غير دقيقة ➝ إضرار بالعملية التعليمية.

تطبيق سلوكيات صحيحة ومسؤولة

1-الالتزام بذكر المصادر عند استخدام أي محتوى رقمي
2-احترام حقوق التأليف والنشر وعدم انتهاكها
3-مراجعة دقة وصحة المعلومات قبل مشاركتها..
4-الالتزام بسياسات وقوانين استخدام الإنترنت داخل المدرسة.
5-أن يكون الأخصائي قدوة في توعية الطلاب بحقوقهم وواجباتهم الرقمية.



`,
    isDone: true,
    jumpToTime: 152,
    stopAtTime: 147,
    xPercent: 91.5,
    yPercent1: 58.5,
    yPercent2: 69.5,
    xPercent2: 90,
    yPercent3: 38,
    yPercent4: 50,

  },
  {
    id: 4,
    name: "الدرس الرابع",
    title: "مهارة الوصول الرقمي ",
    video: "/test4.mp4",
    questions: [
      { time: 5, question: "من ضمن أدوار أخصائي مصادر التعلم في تعزيز الوصول الرقمي:", options: ["السماح باستخدام الأجهزة فقط خلال الحصص الدراسية", "توفير دعم تقني للطلبة دون إشراك المعلمين", ". التنسيق مع الإدارة لتوفير بيئة رقمية متاحة لجميع الفئات ", "تقييد استخدام الإنترنت لمنع التشتت داخل المركز"], answer: ". التنسيق مع الإدارة لتوفير بيئة رقمية متاحة لجميع الفئات " },
      { time: 10, question: "أي المواقف التالية يعكس مشكلة في العدالة الرقمية؟", options: ["استخدام الطلاب أدوات متنوعة لإنجاز مهامهم", ". عدم تمكين بعض المعلمين من الدخول على النظام الرقمي", "تنظيم ورشة تدريبية لجميع المعلمين على منصة جديدة", " تحديث أجهزة المركز لتسريع الخدمات"], answer: ". عدم تمكين بعض المعلمين من الدخول على النظام الرقمي" },
    ],
    Objectives: `1-أن يُعرَّف مفهوم الوصول الرقمي وأبعاده.
2-أن تُوضَّح التحديات المرتبطة بعدم تكافؤ فرص الوصول إلى التكنولوجيا.
3-أن تُطبَّق ممارسات تسهم في تعزيز مبدأ تكافؤ الفرص الرقمية في بيئة التعلم.
`,
    content: `
الوصول الرقمي هو إتاحة التكنولوجيا والمصادر الرقمية للجميع بشكل عادل وشامل.ويتضمن:
إتاحة الأجهزة والإنترنت للجميع.
توفير موارد تعليمية إلكترونية قابلة للوصول (مثل ملفات ميسّرة لذوي الإعاقة البصرية أو السمعية).
إزالة العوائق التقنية التي تمنع بعض الفئات من المشاركة الفعالة.

التحديات المرتبطة بعدم تكافؤ الوصول

1-الفجوة الرقمية بين الطلاب في المدن والقرى.
2-ضعف الاتصال بالإنترنت أو ارتفاع تكلفته.
3-نقص الأجهزة الحديثة لدى بعض الفئات.
4-غياب المحتوى المناسب لذوي الاحتياجات الخاصة.

ممارسات لتعزيز الوصول الرقمي

1-تهيئة منصات التعليم الإلكتروني بحيث تدعم الوصول لذوي الإعاقة (مثل قارئ الشاشة أو الترجمة النصية).
2-توفير معامل حاسوب مجهزة لجميع الطلاب في المدارس.
3-تصميم موارد تعليمية بأكثر من صيغة (نص، صوت، فيديو).
4-تعزيز ثقافة "التكنولوجيا للجميع" كجزء من قيم المواطنة الرقمية.
5-إن الوصول الرقمي يمثل البوابة الحقيقية للمواطنة الرقمية. فمن دون ضمان وصول عادل للتكنولوجيا، يبقى الحديث عن المشاركة الرقمية أو حماية الحقوق ناقصًا. لذلك، يُعدّ الوصول الرقمي ركيزة أساسية لتحقيق المساواة والعدالة داخل المجتمع التعليمي.

`,
    isDone: true,
    // jumpToTime: 159,
    // stopAtTime: 204,
        jumpToTime:88,
    stopAtTime:83,
        xPercent:91.5,
    yPercent1:48.5,
    yPercent2:65,
        xPercent2:90,
    yPercent3:38,
    yPercent4:50,

  },
  {
    id: 5,
    name: "الدرس الخامس",
    title: "السلوك الرقمي",
    video: "/test5.mp4",
    questions: [
      { time: 5, question: "في دورة تدريبية عبر الإنترنت، لاحظ أخصائي المركز وجود تعليقات غير لائقة من أحد الحضور. ما التصرف المناسب؟", options: [". حذف الحضور من الجلسة", ". تجاهل الأمر حتى لا ", ". تنبيه المشاركين لأهمية الالتزام بآداب السلوك ", "إنهاء الجلسة فورًا"], answer: ". تنبيه المشاركين لأهمية الالتزام بآداب السلوك " },
      { time: 10, question: "من مؤشرات السلوك الرقمي الإيجابي في بيئة التعلم الافتراضية:", options: ["الردود المختصرة دائمًا لتوفير الوقت", "استخدام الألقاب العامة دون احترام المكانة العلمية", "احترام أوقات إرسال الرسائل واستخدام لغة رسمية", "مناقشة المواضيع خارج السياق لخلق جو تفاعلي"], answer: "احترام أوقات إرسال الرسائل واستخدام لغة رسمية" },
    ],
    Objectives: `1-أن يُعرَّف مفهوم السلوك الرقمي وأهميته في الفضاء الإلكتروني.
2-أن تُميَّز الفروق بين السلوكيات الرقمية الصحيحة وغير الصحيحة.
3-أن تُطبَّق آداب التعامل في البيئات الرقمية بما يحقق الاحترام والمسؤولية.
`
    ,
    content: `
    مع توسع استخدام المنصات الرقمية ووسائل التواصل، أصبح السلوك الرقمي عنصرًا أساسيًا في تحديد صورة الفرد وسمعته داخل المجتمع الرقمي. السلوك الرقمي هو مرآة للأخلاقيات والقيم التي يلتزم بها الشخص عند تفاعله عبر الإنترنت، سواء في بيئة تعليمية أو مهنية أو اجتماعية. إن التزام الجميع بآداب التعامل الرقمي يسهم في خلق فضاء إلكتروني آمن، محترم، وعادل.

    السلوك الرقمي هو مجموعة القواعد والآداب الأخلاقية التي تنظّم تفاعل الأفراد عبر الإنترنت، بما يضمن أن يكون التواصل راقيًا، خاليًا من الإساءة، ومبنيًا على الاحترام المتبادل.وتكمن أهميته في:

1-تعزيز بيئة تعليمية آمنة.
2-الحد من التنمّر أو الإساءة الرقمية.
3-تحسين جودة التفاعل بين المعلمين والطلاب.
4-حماية سمعة الفرد والمؤسسة التعليمية.


الفروق بين السلوكيات الصحيحة وغير الصحيحة
أولا : السلوكيات الصحيحة
1-استخدام لغة مهذبة ومهنية في المراسلات.
2-احترام آراء الآخرين حتى في حالة الاختلاف.
3-الالتزام بالصدق عند نشر المعلومات.
4-الاستئذان قبل مشاركة بيانات أو صور تخص الآخرين.

ثانيا : السلوكيات غير الصحيحة

1-استخدام ألفاظ جارحة أو ساخرة.
2-نشر إشاعات أو محتويات مضللة.
3-الاستهزاء بآراء الآخرين أو إقصاؤهم.
4-إرسال رسائل في أوقات غير مناسبة


1-تطبيق آداب التعامل في البيئات الرقمية
2-الالتزام بالتحية والختام المناسب في الرسائل الرسمية.
3-ضبط الانفعالات وتجنّب الرد أثناء الغضب.
4-استخدام الرموز التعبيرية والاختصارات بشكل معتدل ومناسب للسياق.
5-التعامل مع المنصات التعليمية باعتبارها امتدادًا للصف الدراسي الحقيقي.
6-أن يكون الشخص قدوة في نشر ثقافة الاحترام والمسؤولية عبر الإنترنت.

من خلال ذلك نستنتج أن السلوك الرقمي هو حجر الأساس في بناء مجتمع إلكتروني قائم على الاحترام والتعاون. فالبيئة الرقمية لا تختلف عن الواقع، وما يُكتب أو يُنشر يظل أثره طويلًا. ومن خلال الالتزام بآداب التعامل عبر الإنترنت، يتحقق التوازن بين الحرية والمسؤولية، ويُسهم في تعزيز قيم المواطنة الرقمية.


    `,

    isDone: true,
    jumpToTime: 159,
    stopAtTime: 148,
    xPercent: 91.5,
    yPercent1: 48.5,
    yPercent2: 59.5,
    xPercent2: 90,
    yPercent3: 53,
    yPercent4: 68,

  },
]